import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ru from './languages/ru.json';
import en from './languages/en.json';
import { uiKitPlugin } from '@sinups/ui-kit';
import { Languages } from '../admin-app/commonSettings';

const resources = {
  en: {
    translation: en
  },
  ru: {
    translation: ru
  }
};

const browserLanguage = navigator.language?.split('-')[0] as keyof Languages;
const localLanguage = localStorage.getItem('lng') as keyof Languages;

export const defaultLang = localLanguage || browserLanguage;

i18n
  .use(initReactI18next)
  .use(uiKitPlugin)
  .init({
    resources,
    lng: defaultLang,
    fallbackLng: 'ru',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
